import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    catalogues: {
      typesDeDonsBack: ["Don unique", "Don récurrent"], // Doit matcher pour le file data
      typesDeDonsFront: ["Don unique", "Don mensuel"],
      ids: {
        paysCanada: '',
        paysEtatsUnis: '',
        provinceQuebec: ''
      }
    },
    contact: {
      sexe: '',
      prenom: '',
      nom: '',
      adresse: '',
      ville: '',
      province: '',
      codePostal: '',
      pays: '',
      courriel: '',
      telephoneResidentiel: '',
      cellulaire: '',
      desireRecevoir: false,
      anneeDeNaissance: '',
      origine: '',
    },
    paiement: {
      jour: 1,
      token: '',
      method: ''
    },
    donate: {
      params: null,
      typeDeDon: 0,
      montantDon: '0',
      campagne: '',
    },
    adhesion: {
      montantAdhesion: undefined,
      categorieAdhesion: "",
    },
    montantsUniquesPossibles: [
      { v: 30, t: "30$" },
      { v: 50, t: "50$" },
      { v: 100, t: "100$" },
      { v: 250, t: "250$" },
      { v: 0, t: "Autre montant" }
    ],
    montantsMensuelsPossibles: [
      { v: 10, t: "10$/mois" },
      { v: 15, t: "15$/mois" },
      { v: 20, t: "20$/mois" },
      { v: 30, t: "30$/mois" },
      { v: 0, t: "Autre mensualité" }
    ],
    montantsAdhesionsPossibles: []
  },
  getters: {
    getCatalogues(state) {
      return state.catalogues
    },
    getResumeDon(state) {
      var montant = state.donate.montantDon.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$& ').replace(".", ",");
      if (state.donate.typeDeDon === 0) {
        return montant + "$ CAD"
      } else if (state.donate.typeDeDon === 1) {
        return montant + "$ CAD/mois"
      }
      return "Erreur"
    },
    getContact(state) {
      return state.contact
    },
    getTypesDeDon(state) {
      return state.catalogues.typesDeDonsFront
    },
    getTypeDeDon(state) {
      return state.donate.typeDeDon
    },
    getMontantDon(state) {
      return state.donate.montantDon
    },
    getMontantAdhesion(state) {
      return state.adhesion.montantAdhesion
    },
    getCategorieAdhesion(state) {
      return state.adhesion.categorieAdhesion
    },
    getHolderName(state) {
      return state.contact.prenom + " " + state.contact.nom
    },
    getCataloguesIds(state) {
      return state.catalogues.ids
    },
    getParamsFormulaire(state) {
      return state.donate.params
    },
    isCanada(state) {
      return state.contact.pays === state.catalogues.ids.paysCanada;
    },
    getMontantsUniquesPossibles(state) {
      return state.montantsUniquesPossibles
    },
    getMontantsMensuelsPossibles(state) {
      return state.montantsMensuelsPossibles
    },
    getMontantsAdhesionPossibles(state) {
      return state.montantsAdhesionsPossibles
    }
  },
  mutations: {
    setContact(state, value) {
      state.contact = value
    },
    setPaymentToken(state, value) {
      state.paiement.token = value
    },
    setPaymentMethod(state, value) {
      state.paiement.method = value
    },
    setPaymentJour(state, value) {
      state.paiement.jour = value
    },
    setTypeDeDon(state, value) {
      state.donate.typeDeDon = value
    },
    setCampagne(state, value) {
      state.donate.campagne = value
    },
    setMontantDon(state, value) {
      state.donate.montantDon = value
    },
    setMontantAdhesion(state, value) {
      state.adhesion.montantAdhesion = value
    },
    setCategorieAdhesion(state, value) {
      state.adhesion.categorieAdhesion = value
    },
    setCatalogue(state, { key, values }) {
      state.catalogues[key] = values
    },
    setMontantsAdhesionsPossibles(state, value) {
      state.montantsAdhesionsPossibles = value
    },
    setCataloguesIds(state, value) {
      state.catalogues.ids = value
    },
    setParamsFormulaire(state, value) {
      state.donate.params = value
    },

  },
  actions: {
    loadCatalogue(context, key) {
      return Vue.axios.get(`${process.env.VUE_APP_BASE_URL}catalogues/${key}`).then(res => {
        let values = res.data
        if (key == 'anneesDeNaissance') {
          values.sort((a, b) => { return parseInt(a.text) < parseInt(b.text) ? 1 : -1 })
        }
        return context.commit('setCatalogue', { key, values })
      })
    },
    loadMontantsAdhesion(context) {
      return Vue.axios.get(`${process.env.VUE_APP_BASE_URL}catalogues/categoriesDeMembre`)
        .then(res => {
          let values = res.data.map(fd => { return { v: fd.value, t: fd.text, code: fd.code } })
          values.sort((a, b) => { return parseInt(b.code) - parseInt(a.code) })
          return context.commit('setMontantsAdhesionsPossibles', values)
        })
    },
    loadCataloguesIds(context) {
      return Vue.axios.get(process.env.VUE_APP_BASE_URL + "catalogues/ids").then(res => {
        return context.commit('setCataloguesIds', res.data)
      })
    },
    loadParamsFormulaire({
      commit
    }, campagneId) {
      return Vue.axios.get(process.env.VUE_APP_BASE_URL + "dons/paramsFormulaire?campagneId=" + campagneId).then(res => {
        return commit('setParamsFormulaire', res.data)
      })
    },
    createSasDeDon({ state }) {
      // Création du SAS de don
      return Vue.axios.post(process.env.VUE_APP_BASE_URL + "dons/sas", {
        ContactDTO: {
          Genre: state.contact.sexe,
          Prenom: state.contact.prenom,
          Nom: state.contact.nom,
          Adresse: state.contact.adresse,
          Ville: state.contact.ville,
          Province: state.contact.province,
          CodePostal: state.contact.codePostal,
          Pays: state.contact.pays,
          Courriel: state.contact.courriel,
          TelephoneResidentiel: state.contact.telephoneResidentiel,
          Cellulaire: state.contact.cellulaire,
          DesireRecevoir: state.contact.desireRecevoir
        },
        DonDTO: {
          MontantMultipliePar100: parseInt(state.donate.montantDon * 100),
          TypeDeDon: state.catalogues.typesDeDonsBack[state.donate.typeDeDon],

        },
        PaiementDTO: {
          ModeDePaiement: state.paiement.method,
          JourDuPrelevement: state.paiement.jour,
          Token: state.paiement.token
        },
        Campagne: state.donate.campagne
      })
    },
    createSasAdhesion({ state }) {
      // Création du SAS adhésion
      return Vue.axios.post(process.env.VUE_APP_BASE_URL + "adhesions/sas", {
        ContactDTO: {
          Genre: state.contact.sexe,
          Prenom: state.contact.prenom,
          Nom: state.contact.nom,
          Adresse: state.contact.adresse,
          Ville: state.contact.ville,
          Province: state.contact.province,
          CodePostal: state.contact.codePostal,
          Pays: state.contact.pays,
          Courriel: state.contact.courriel,
          TelephoneResidentiel: state.contact.telephoneResidentiel,
          Cellulaire: state.contact.cellulaire,
          DesireRecevoir: state.contact.desireRecevoir,
          AnneeDeNaissance: state.contact.anneeDeNaissance,
          Origine: state.contact.origine
        },
        Adhesion: {
          montantMultipliePar100: parseInt(state.adhesion.montantAdhesion * 100),
          categorieAdhesion: state.adhesion.categorieAdhesion
        },
        PaiementDTO: {
          ModeDePaiement: state.paiement.method,
          Token: state.paiement.token
        }
      })
    },
    checkIfMembre({ state }) {
      return Vue.axios.post(process.env.VUE_APP_BASE_URL + "adhesions/check-if-membre", {
        Prenom: state.contact.prenom,
        Nom: state.contact.nom,
        Courriel: state.contact.courriel,
      })
    }
  },
  modules: {}
})